import dynamic from 'next/dynamic';
import Title from "@/components/Title";

const Awards = dynamic(() => import('@/components/Home/Awards'), {
  loading: () => <div className="h-36 bg-gray-100 animate-pulse" />
});

const AwardsSection = ({ data, loading }) => {
  // Rich Text helper for Strapi Blocks
  const renderRichText = (blocks) => {
    if (typeof blocks === 'string') return blocks;
    if (Array.isArray(blocks)) {
      return blocks.map(block => {
        if (block.type === 'paragraph') {
          return block.children.map(child => child.text).join('');
        }
        return '';
      }).join('\n');
    }
    return '';
  };

  if (loading && !data) {
    return (
      <div className="w-full h-96 bg-gray-50 animate-pulse flex items-center justify-center">
        <p className="text-gray-400">Loading Awards...</p>
      </div>
    );
  }

  return (
    <div className='w-full top_bottom_space'>
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
        <div className="w-full heading_space_bottom">
          <Title
            heading={data?.Title || "Celebrating Excellence & Achievements"}
            subText={renderRichText(data?.Description) || "Recognised by leading national and industry bodies for excellence in skill-based education, industry relevance, and innovation aligned with the National Education Policy 2020, establishing MSU as a leading university in Northeast India."}
            color="text-black"
            subTextColor="text-black/70"
            align="text-left"
          />
        </div>
      </div>
      <Awards data={data?.Award_block} />
    </div>
  );
};

export default AwardsSection;
